var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{attrs:{"row":"","wrap":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('div',{staticClass:"drawing",attrs:{"id":"loading"}},[_c('div',{staticClass:"loading-dot switchq",style:({
          color: _vm.$vuetify.theme.themes.light.switchq,
        })})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }